// Studio constants — extracted from Studio.jsx for readability and reuse.
// No behavior change: identical values and shapes.
import { Users, Upload, Sparkles, Download } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

// Curated 8-image mosaic showcasing Geneo AI's Afro Sci-Fi aesthetic.
// 100% on-brand — generated by Nano Banana (via /app/backend/seed_hero_mosaic.py)
// and hosted on Emergent Object Storage.
export const MOSAIC_IMAGES = [
  `${API}/api/files/geneo/hero-mosaic/egyptian-futura.jpg`,   // Egyptian glyphs
  `${API}/api/files/geneo/hero-mosaic/cosmic-queen.jpg`,      // Cosmic royalty portrait
  `${API}/api/files/geneo/hero-mosaic/wakanda-warrior.jpg`,   // Vibranium tech guardian
  `${API}/api/files/geneo/hero-mosaic/scifi-explosion.jpg`,   // Sci-Fi Action
  `${API}/api/files/geneo/hero-mosaic/2d-anime-hero.jpg`,     // 2D African anime
  `${API}/api/files/geneo/hero-mosaic/cultural-fashion.jpg`,  // Editorial fashion
  `${API}/api/files/geneo/hero-mosaic/3d-character.jpg`,      // 3D character render
  `${API}/api/files/geneo/hero-mosaic/solar-desert.jpg`,      // Solar desert dynasty
];

export const ASPECTS = [
  { id: "1:1", label: "Square 1:1" },
  { id: "4:3", label: "Landscape 4:3" },
  { id: "3:4", label: "Portrait 3:4" },
  { id: "16:9", label: "Cinema 16:9" },
  { id: "9:16", label: "Vertical 9:16" },
  { id: "21:9", label: "Ultra-Wide 21:9" },
];

export const RESOLUTIONS = [
  { id: "1K", label: "1K · Standard" },
  { id: "2K", label: "2K · Sharp" },
  { id: "4K", label: "4K · Cinematic" },
];

export const VIDEO_RESOLUTIONS = [
  { id: "480p", label: "480p · Fast" },
  { id: "720p", label: "720p · Standard" },
  { id: "1080p", label: "1080p · Cinema" },
];

export const MODES = [
  { id: "turnaround", label: "Character Sheet", icon: Users },
];

// Streamlined 3-step pipeline
export const PIPELINE_STEPS = [
  { id: 1, key: "upload", label: "Upload", icon: Upload },
  { id: 2, key: "edit", label: "Edit", icon: Sparkles },
  { id: 3, key: "download", label: "Download", icon: Download },
];

export const HISTORY_KEY = "geneo_pipeline_history_v1";
export const readHistory = () => {
  try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]"); } catch { return []; }
};
export const writeHistory = (arr) =>
  localStorage.setItem(HISTORY_KEY, JSON.stringify(arr.slice(0, 12)));

// Character Sheet — 10 reference views rendered in a magazine-style grid.
// Row 1: 3 full-body views · Row 2: 4 head studies · Row 3: 3 close-up details.
export const TURN_VIEWS = [
  "front", "side", "back",
  "head_front", "head_side", "head_3q", "head_back",
  "face", "hands", "outfit",
];

export const TURN_LABELS = {
  front: "FULL · FRONT",
  side: "FULL · SIDE",
  back: "FULL · BACK",
  head_front: "HEAD · FRONT",
  head_side: "HEAD · SIDE",
  head_3q: "HEAD · 3/4",
  head_back: "HEAD · BACK",
  face: "CLOSE-UP · FACE",
  hands: "CLOSE-UP · HANDS",
  outfit: "CLOSE-UP · OUTFIT",
};

// Grid row groupings for magazine-style layout
export const SHEET_ROWS = [
  { title: "FULL BODY", keys: ["front", "side", "back"] },
  { title: "HEAD STUDY", keys: ["head_front", "head_side", "head_3q", "head_back"] },
  { title: "DETAILS", keys: ["face", "hands", "outfit"] },
];
